// A grey wolf, modelled facing +X: a lean grey body on tall legs, a low-held
// head, erect ears and a straight tail. Ported 1:1 from age-of-mcp's classic
// wolf.ts, restoring its leg loop + body/head/muzzle/ear/tail composition.
import * as THREE from "three";
import { defineModel, type Part } from "../../lib";

function partsFor(): Part[] {
  const parts: Part[] = [];
  for (const [x, z] of [[0.06, 0.028], [0.06, -0.028], [-0.06, 0.028], [-0.06, -0.028]]) {
    parts.push({ geometry: new THREE.CylinderGeometry(0.008, 0.007, 0.092, 4),
      color: "#5a5e63", position: [x!, 0.046, z!] });
  }
  parts.push(
    { geometry: new THREE.IcosahedronGeometry(0.045, 0), color: "#787c82",
      position: [0, 0.092, 0], scale: [1.9, 0.95, 0.8] },              // body
    { geometry: new THREE.IcosahedronGeometry(0.03, 0), color: "#82868c",
      position: [0.1, 0.095, 0] },                                     // head
    { geometry: new THREE.ConeGeometry(0.014, 0.035, 4), color: "#6e7278",
      position: [0.13, 0.09, 0], rotation: [0, 0, -Math.PI / 2] },     // muzzle
    { geometry: new THREE.ConeGeometry(0.01, 0.022, 4), color: "#5a5e63",
      position: [0.092, 0.122, 0.015] },                              // ear
    { geometry: new THREE.ConeGeometry(0.01, 0.022, 4), color: "#5a5e63",
      position: [0.092, 0.122, -0.015] },
    { geometry: new THREE.IcosahedronGeometry(0.02, 0), color: "#e6e2da",
      position: [0.07, 0.07, 0], scale: [1.1, 1, 1] },                // pale throat
    { geometry: new THREE.CylinderGeometry(0.008, 0.014, 0.06, 4), color: "#6e7278",
      position: [-0.105, 0.082, 0], rotation: [0, 0, 0.7] },          // tail
  );
  return parts;
}

export const wolf = defineModel({
  id: "wolf",
  batchId: "standard",
  name: "Wolf",
  tags: ["creature","wolf","low-poly","age-of-mcp","classic"],
  summary: "Low-poly wolf.",
  description: "Ported from the age-of-mcp gallery.",
  author: "age-of-mcp",
  footprint: 0.13,
  parts: () => partsFor(),
  animations: [],
});
